import { ApiError } from 'api/openapi';

import { useErrorHandlingSlice } from 'app/error/slice';
import { useDispatch } from 'react-redux';

export const useOnErrorCallBack = () => {
  const dispatch = useDispatch();
  const { actions } = useErrorHandlingSlice();

  const onErrorCallBack = (
    errorBody?: Error,
    customError?: string,
    showErrorMessage: boolean = true, // Default to true if not provided
  ) => {
    if (!showErrorMessage) {
      // If showErrorMessage is false, do nothing
      return;
    }

    var errorData = errorBody as ApiError;
    const defaultErrorMessage = customError ?? 'Something went wrong';

    if (!errorData || !errorData.body) {
      dispatch(
        actions.dispatchToast({
          errorTxt: defaultErrorMessage,
          show: true,
          errorType: 'error',
        }),
      );
      return;
    }

    const error = errorData.body.errors ?? errorData.body;

    if (Array.isArray(error)) {
      // Handle errors that are arrays
      error.forEach(errItem => {
        const message =
          typeof errItem === 'string'
            ? errItem
            : errItem?.message || defaultErrorMessage;
        dispatch(
          actions.dispatchToast({
            errorTxt: `${message}`,
            show: true,
            errorType: 'error',
          }),
        );
        dispatch(actions.setToastDelay(5000));
      });
    } else if (typeof error === 'object' && error !== null) {
      // Handle errors that are objects (key-value pairs)
      const allErrorMessages: string[] = [];

      Object.entries(error).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          // Handle array of error messages for this field
          value.forEach(msg => {
            const message = typeof msg === 'string' ? msg : JSON.stringify(msg);
            allErrorMessages.push(message);
          });
        } else {
          // Handle single error message for this field
          const message =
            typeof value === 'string' ? value : JSON.stringify(value);
          allErrorMessages.push(message);
        }
      });

      // Display all error messages in a single toast with comma separator
      if (allErrorMessages.length > 0) {
        dispatch(
          actions.dispatchToast({
            errorTxt: allErrorMessages.join(', '),
            show: true,
            errorType: 'error',
          }),
        );
        dispatch(actions.setToastDelay(5000));
      }
    } else if (typeof error === 'string') {
      // Handle string errors
      dispatch(
        actions.dispatchToast({
          errorTxt: `${error}`,
          show: true,
          errorType: 'error',
        }),
      );
      dispatch(actions.setToastDelay(5000));
    } else {
      // Fallback for unknown error formats
      dispatch(
        actions.dispatchToast({
          errorTxt: defaultErrorMessage,
          show: true,
          errorType: 'error',
        }),
      );
      dispatch(actions.setToastDelay(5000));
    }
  };

  return {
    onErrorCallBack,
  };
};
